import { useEffect, useRef } from 'react';
import { isPopupOpen } from '../../../shared/utils/popupUtils';

/**
 * Hook for auto-focusing placeholder task when it appears
 * @param {Object} params - Configuration object
 * @param {number} params.tasksLength - Number of tasks
 * @param {boolean} params.loading - Whether tasks are loading
 * @param {string|null} params.editingTaskId - Currently editing task ID
 * @param {Function} params.setEditingTaskId - Function to set editing task ID
 */
export function useTaskAutoFocus({
  tasksLength,
  loading,
  editingTaskId,
  setEditingTaskId
}) {
  const hasFocusedPlaceholderRef = useRef(false);

  useEffect(() => {
    if (tasksLength !== 0 || loading) {
      hasFocusedPlaceholderRef.current = false;
      return;
    }
    if (isPopupOpen()) return;
    if (document.activeElement?.closest?.('.sidebar')) return;
    if (document.activeElement?.closest?.('.file-name-container')) return;
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) return;

    const placeholderElement = document.querySelector('.task-text[data-react-key="placeholder_client_key"]');
    if (!placeholderElement) return;
    if (editingTaskId !== 'placeholder_client_key') {
      setEditingTaskId('placeholder_client_key');
    }
    if (!hasFocusedPlaceholderRef.current) {
      placeholderElement.focus();
      const range = document.createRange();
      range.setStart(placeholderElement, 0);
      range.collapse(true);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      hasFocusedPlaceholderRef.current = true;
    }
  }, [tasksLength, loading, editingTaskId, setEditingTaskId]);
}
